import { render, staticRenderFns } from "./Educacao.vue?vue&type=template&id=2d5e3d47"
import script from "./Educacao.vue?vue&type=script&lang=js"
export * from "./Educacao.vue?vue&type=script&lang=js"
import style0 from "./Educacao.vue?vue&type=style&index=0&id=2d5e3d47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports